<template>
    <v-menu
        :ref="reference"
        v-model="date_visible"
        :close-on-content-click="false" 
        transition="scale-transition" 
        offset-y
    >
        <template v-slot:activator="{ on }">
            <AppTextFieldV2 
                :label="label"
                :value="formatedDate"
                readonly 
                v-on="on"
                :disabled="disabled"
                :error="error"
                :background_color="background_color"
                :append-icon="clearable && date ? 'mdi-close-circle' : ''"
                @click:append="clearDate"
            />
        </template>
        <v-date-picker
            v-model="date"
            no-title
            @change="handleDateChange"
            class="low-size-font"
            :max="max"
            :min="min"
        />
    </v-menu>
</template>

<script>
import AppTextFieldV2 from './AppTextFieldV2.vue';

export default {
    name: 'AppDateFieldV2',
    components: {
        AppTextFieldV2
    },
    props: {
        value: String,
        label: {
            type: String,
            default: ''
        },
        reference: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        error: {
            type: Boolean,
            default: false
        },
        background_color: {
            type: String,
            default: 'white'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        max: {
            type: String,
            default: undefined
        },
        min: {
            type: String,
            default: undefined
        }
    },
    data() {
        return {
            date_visible: false,
            date: this.value,
        }
    },
    methods: {
        handleDateChange (e) {
            this.date_visible = false;
            this.$emit('input', e);
            // console.log(e)
        },
        clearDate() {
            if (this.clearable && !this.disabled) {
                this.date = null;
                this.$emit('input', null);
            }
        }
    },
    computed:{
        formatedDate() {
            let fdate = this.date;
            return fdate ? new Date(fdate).toLocaleDateString('es-ES', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            }) : '';
        },
    },
    watch: {
        value(newVal) {
            this.date = newVal;
        }
    }
}
</script>